import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import StepService from 'src/services/steps.service'

import { QUERY_KEYS } from 'src/constants'

const useStepAccountsConnections = () => {
  const { id } = useParams()

  return useQuery(
    [QUERY_KEYS.STEP_ACCOUNTS_CONNECTION, id],
    () => StepService.getStepAccountsConnections(id),
    { keepPreviousData: true },
  )
}

export { useStepAccountsConnections }
